import { inboundShipmentIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const bulkDeleteShipments = {
  name: "bulkDeleteShipments" as const,
  input: z.object({
    inboundShipmentIds: z.array(inboundShipmentIdFormat.schema),
  }),
  output: z.object({ success: z.boolean() }),
};
